export default __webpack_public_path__ + "static/media/ti.f4a93a26.svg";